import Splide from '@splidejs/splide';

export const init = () => {
    const initializeSplideCarousels = (container) => {
        const carousels = container.querySelectorAll('.carousel_type-7');
        if (!carousels.length) return;

        carousels.forEach((item) => {
            const splideOptions = {
                arrows: false,
                pagination: true,
                autoplay: 'pause',
                interval: 2000,
                gap: Number(item.dataset.gap),
                padding: 0,
                perPage: Number(item.dataset.items),
                perMove: Number(item.dataset.items),
                rewind: true,
                classes: {
                    pagination: 'splide__pagination g-pagination__type-1',
                },
                drag: false,
                breakpoints: {
                    1311: { perPage: 3, perMove: 3 },
                    750: { perPage: 2, perMove: 2 },
                    450: { perPage: 1, padding: 0, perMove: 1 },
                },
            };

            const splide = new Splide(item, splideOptions).mount();
            const { Controller, Autoplay } = splide.Components;

            const autoplayButton = item.querySelector('.splide__toggle');
            const arrowLeft = item.querySelector('.btn--prev');
            const arrowRight = item.querySelector('.btn--next');
            const filterButton = item.querySelector('.btn--filter');

            const handleArrowsState = () => {
                const isStart = Controller.getIndex() === 0;
                const isEnd = Controller.getIndex() === Controller.getEnd();
                arrowLeft.classList.toggle('disabled', isStart);
                arrowRight.classList.toggle('disabled', isEnd);
                if (isEnd) Autoplay.pause();
            };

            if (splide.length > item.dataset.items) {
                splide.on('move', handleArrowsState);
                arrowLeft.addEventListener('click', () => { Controller.go('<'); Autoplay.pause(); });
                arrowRight.addEventListener('click', () => { Controller.go('>'); Autoplay.pause(); });
                autoplayButton.addEventListener('click', () => { if (!Autoplay.isPaused()) Controller.go('>'); });

                if (filterButton) {
                    const filterSelector = item.querySelector('.js-filter-selector');
                    const applyFilter = item.querySelector('.js-filter-button');
                    const slides = item.querySelectorAll('.splide__slide');

                    filterButton.addEventListener('click', (e) => {
                        if (filterButton.lastElementChild.classList.contains('active')) {
                            if (!filterButton.lastElementChild.contains(e.target))
                                filterButton.lastElementChild.classList.remove('active');
                        } else {
                            filterButton.lastElementChild.classList.add('active');
                        }
                    });
        
                    filterButton.lastElementChild.querySelector('.js-close').addEventListener('click', (e) => {
                        e.stopPropagation();
                        filterButton.lastElementChild.classList.remove('active');
                    });
                    
                    document.addEventListener("click", (e) => {
                        if (!filterButton.contains(e.target)) filterButton.lastElementChild.classList.remove('active');
                    });
                    applyFilter.addEventListener('click', (e) => {
                        e.stopPropagation();
                        filterButton.lastElementChild.classList.remove('active');
                        Controller.go(0);
                        let arr = slides;
                        if (filterSelector.value != '') {
                            arr.forEach((card) => {
                                const vallArr = card.dataset.filter.split(',');
                                if (!vallArr.includes(filterSelector.value)) {
                                    card.remove();
                                } else {
                                    splide.add(card);
                                }
                            });
                        } else {
                            splide.remove('.splide__slide');
                            slides.forEach((card) => {
                                splide.add(card);
                            });
                        }
                        splide.refresh();
                        if (splide.length <= item.dataset.items) {
                            autoplayButton.classList.add('hidden');
                            arrowLeft.classList.add('hidden');
                            arrowRight.classList.add('hidden');
                            filterButton.classList.add('no-after');
                        } else {
                            autoplayButton.classList.remove('hidden');
                            arrowLeft.classList.remove('hidden');
                            arrowRight.classList.remove('hidden');
                            filterButton.classList.remove('no-after');
                        }
                    });
                }

                splide.on('move', () => {
                    item.querySelectorAll('.splide__pagination__page').forEach(button => {
                        button.addEventListener('click', () => Autoplay.pause());
                    });
                });
            } else {
                [autoplayButton, arrowLeft, arrowRight].forEach(el => el.classList.add('hidden'));
            }
        });
    };

    const setupMutationObserver = () => {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            initializeSplideCarousels(node);
                        }
                    });
                }
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    initializeSplideCarousels(document.body);
    setupMutationObserver();
};